import countriesJson from '../country-data/countries-intl-custom.json'

function getPreferredCountryAndLanguage() {
  let language;
  let country;
  if (window.navigator.language.length === 5) {
    const splitLocale = window.navigator.language.split('-');
    language = splitLocale[0];
    country = splitLocale[1];
  } else if (window.navigator.language.length === 2) {
    language = window.navigator.language;
  } else {
    language = 'en';
  }

  return {
    language: language.toLowerCase(),
    country: country?.toLowerCase(),
  };
}

function getAvailableLocales() {
  return countriesJson.reduce((allvalues, country) => {
    allvalues.push(...country.locales.map((locale) => locale.toLowerCase()));
    return allvalues;
  }, []);
}

function findClosestLocale(language, country, availableLocales) {
  const exactLocale = availableLocales.find((locale) => locale === `${language}-${country}`);
  const approximateLocale = availableLocales.find((locale) => locale.startsWith(language));

  return exactLocale || approximateLocale || 'en-gb';
}

function setLocalisedTermsOfUse(translator) {
  const termsOfUseElement = document.getElementById('termsOfUse');
  termsOfUseElement.setAttribute('href', translator.translate('legalLinks.termsOfUse.href'));
  termsOfUseElement.innerHTML = translator.translate('legalLinks.termsOfUse.label');
}

function setLocalisedCookieNotice(translator) {
  const cookieNoticeElement = document.getElementById('cookieNotice');
  cookieNoticeElement.setAttribute('href', translator.translate('legalLinks.cookieNotice.href'));
  cookieNoticeElement.innerHTML = translator.translate('legalLinks.cookieNotice.label');
}

function setLocalisedPrivacyNotice(translator) {
  const privacyNoticeElement = document.getElementById('privacyNotice');
  privacyNoticeElement.setAttribute('href', translator.translate('legalLinks.privacyNotice.href'));
  privacyNoticeElement.innerHTML = translator.translate('legalLinks.privacyNotice.label');
}

function setLocalisedLegalLinks(translator) {
  setLocalisedTermsOfUse(translator);
  setLocalisedCookieNotice(translator);
  setLocalisedPrivacyNotice(translator);
}

function setLocalisedFont(language) {
  const arialUnicodeCountries = ['bg', 'ru', 'ua'];

  if (arialUnicodeCountries.includes(language.toLowerCase())) {
    const body = document.getElementsByTagName('body')[0];
    body.style.fontFamily = 'ArialUnicode';
  }
}

function localiseFontAndLinks(language, translator) {
  setLocalisedFont(language);
  setLocalisedLegalLinks(translator);
}

export { getPreferredCountryAndLanguage, getAvailableLocales, findClosestLocale, localiseFontAndLinks };